import { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import {useAuth} from "../auth/AuthProvider";

export const ExportDatasetButton = () => {
    const [downloading, setDownloading] = useState(false);

    const {token} = useAuth();

    const handleExport = () => {
        const url = `/api/machines/export_dataset`;

        setDownloading(true);

        return fetch(url, {
            method: "GET",
            headers: { Authorization: `${token}` },
        })
            .then((res) => {
                if (!res.ok) throw new Error(`Export failed (HTTP ${res.status})`);

                // parse filename *before* consuming body
                const cd = res.headers.get("Content-Disposition") || "";
                const m = cd.match(/filename\*?=(?:UTF-8'')?"?([^\";]+)/i);
                const filename =
                    (m ? decodeURIComponent(m[1]) : null) ||
                    `export_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-")}.csv`;

                // return both body promise and filename together
                return res.blob().then((blob) => ({ blob, filename }));
            })
            .then(({ blob, filename }) => {
                const blobUrl = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = blobUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(blobUrl);
            }).finally( () => {
                setDownloading(false);
            });

    }

    return (
        <Button onClick={handleExport} disabled={downloading} variant="outline-primary">
            {downloading ? (
                <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Preparing CSV…
                </>
            ) : (
                "Export Dataset"
            )}
        </Button>
    );
};